import React, {useEffect, useState} from "react";
import style from './preMadeReportCard.module.scss';
import {Inventory, Pricing, productInfo, RobotData} from "../../../../helpers/consts/reportConsts"
import toPersianNumber from "../../../../helpers/actions/toPersianNumber"
import ToPersianDate from "../../../../helpers/actions/toPersianDate"

const PreMadeReportCard = (props) => {
    const [reportFeatuersList, setReportFeatuersList] = useState([])
    useEffect(() => {
        if (typeof props !== "undefined" && typeof props.data !== "undefined") {

            Object.keys(props.data).forEach(item => {
                searchArray(productInfo, item)
                searchArray(Pricing, item)
                searchArray(Inventory, item)
                searchArray(RobotData, item)
            })
        }


    }, [props.data])
    const searchArray = (array, key) => {
        let temp = reportFeatuersList;
        array.map(item => {
            if (item.value == key) {
                let index = temp.findIndex(i => i === item.name)
                if (index < 0) {
                    temp.push(item.name);
                }
            }
        });
        setReportFeatuersList([...temp])

    }
// console.log(props.date);
    return (
        <div className={style.wrapper}>
            <div className={style.contentBox}>
                <h1>{toPersianNumber(props.title)}</h1>
                <p>{reportFeatuersList.join(', ')}</p>
                {
                    typeof props.date !== "undefined" && props.date ?
                        <div className={style.label}>
                            تاریخ ساخت گزارش:
                            <p className={style.date}>{toPersianNumber(ToPersianDate(props.date))}</p>
                        </div>
                        : null
                }
            </div>
        </div>
    )
}
export default PreMadeReportCard

